import { createContext, useState, useEffect, useCallback } from "react";
import ChatService from "../services/ChatService";
import { useNavigate } from "react-router-dom";

export const ChatContext = createContext();

export const ChatProvider = ({ children }) => {
  const [conversations, setConversations] = useState([]);
  const [messages, setMessages] = useState([]);
  const [currentChatId, setCurrentChatId] = useState(null); // Aktif sohbet ID'si
  const [currentThreadId, setCurrentThreadId] = useState(null); // Aktif thread ID'si
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const fetchConversations = useCallback(async () => {
    try {
      const fetchedConversations = await ChatService.getConversations();
      setConversations(fetchedConversations);
      setErrorMessage("");
    } catch (error) {
      setErrorMessage("Failed to fetch conversations");
      navigate("/chat/login");
    } finally {
    }
  }, []);

  useEffect(() => {
    fetchConversations();
  }, [fetchConversations]);

  const loadMessagesForConversation = async (conversationId) => {
    setIsLoading(true);
    setErrorMessage("");
    try {
      const fetchedMessages = await ChatService.getMessages(conversationId);
      setMessages(fetchedMessages); // Mesajları güncelle
      setCurrentChatId(conversationId); // Aktif sohbet ID'sini ayarla
      console.log(fetchedMessages)
    } catch (error) {
      setErrorMessage("Failed to load messages for the selected conversation");
    } finally {
      setIsLoading(false);
    }
  };

  const startConversation = async (title) => {
    setIsLoading(true);
    try {
      const newConversation = await ChatService.createConversation(title);
      setConversations((prev) => [...prev, newConversation]);
  
      console.log(newConversation.conversation_id);
      console.log(newConversation.thread_id);
  
      // currentChatId ve currentThreadId'yi hemen güncelle
      setCurrentChatId(newConversation.conversation_id);
      setCurrentThreadId(newConversation.thread_id);
  
      setMessages([]); // Mesajları sıfırla
      setErrorMessage("");
  
      // Sohbet listesini yenile
      await fetchConversations();
      console.log("asdasd")
  
      return newConversation; // Yeni sohbet detaylarını döndür
    } catch (error) {
      setErrorMessage("Failed to start a new conversation");
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  const sendMessage = async (message, conversationId = currentChatId, threadId = currentThreadId) => {
    console.log("Sending message to conversation:", conversationId);
    if (!conversationId) {
      setErrorMessage("No active chat to send message.");
      return;
    }
    setIsLoading(true);
    try {
      const response = await ChatService.sendMessage({
        conversationId, // Öncelikli olarak parametreyi kullan
        question: message,
        threadId,
      });
      setMessages((prev) => [...prev, message, response.response]); // Kullanıcı ve bot mesajları
      setCurrentThreadId(response.thread_id); // Yeni thread ID
      await fetchConversations();
    } catch (error) {
      setErrorMessage("Failed to send message");
      console.error("Error sending message:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const deleteConversation = async (conversationId) => {
    setIsLoading(true);
    try {
      await ChatService.deleteConversation(conversationId);
      setConversations((prev) =>
        prev.filter((conversation) => conversation.conversation_id !== conversationId)
      );
      if (currentChatId === conversationId) {
        setCurrentChatId(null);
        setCurrentThreadId(null);
        setMessages([]);
      }
    } catch (error) {
      setErrorMessage("Failed to delete conversation");
    } finally {
      setIsLoading(false);
    }
  };

  const deleteAllConversations = async () => {
    setIsLoading(true);
    try {
      await ChatService.deleteAllConversations();
      setConversations([]);
      setMessages([]);
      setCurrentChatId(null);
      setCurrentThreadId(null);
    } catch (error) {
      setErrorMessage("Failed to delete all conversations");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ChatContext.Provider
      value={{
        conversations,
        messages,
        isLoading,
        errorMessage,
        fetchConversations,
        startConversation,
        loadMessagesForConversation, // Sohbet mesajlarını yükleme
        sendMessage,
        deleteConversation,
        deleteAllConversations,
        currentChatId, // Aktif sohbet ID'si
        currentThreadId, // Aktif thread ID'si
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};